import React, { Component } from 'react'
import {
    Container, Row, Spinner
} from 'reactstrap'
import './descargas.css'
import ItemArchivo from '../itemArchivo'
import Archivo from '../utilitarios/archivo'
const archivo = new Archivo

export default class Descargas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            archivos: [],
            cargando: false
        }
    }

    componentWillMount() {
        const _this = this
        _this.setState({cargando: true})
        archivo.getArchivos().then(archivos => {
            _this.setState({
                archivos,
                cargando: false
            })
        })
    }

    render() {

        return (
            <Container className="Descargas">
                <h2>Descarga de contenido</h2>
                <Row>
                    {
                        this.state.cargando ? 
                        <div className="spinnerCargando">
                            <Spinner /> {' '} Cargando...
                        </div>
                        :
                        this.state.archivos.map(archivo => <ItemArchivo key={archivo.id} archivo={archivo} />)
                    }
                </Row>
            </Container>
        )
    }

}